<uikit-async-ui
  [loading]="scoresState.isLoading$ | async"
  [error]="isFailed$ | async"
  [data]="scoresState.workResults$ | async"
>
  <ng-container *successData="let scores">
    <h2
      [matTooltip]="('MEDDIC.SCORE_DESCRIPTIONS.' + scoreI18nKey | translate) || scores[scoresKey]"
      [ngClass]="{
        green: scores[scoresKey] >= 2,
        yellow: 1 <= scores[scoresKey] && scores[scoresKey] < 2,
        red: scores[scoresKey] < 1
      }"
    >
      {{ scores[scoresKey] }}
    </h2>
  </ng-container>
  <ng-container error>
    <mat-icon [matTooltip]="'MEDDIC.FAILED_TO_LOAD' | translate">error_outline</mat-icon>
  </ng-container>
</uikit-async-ui>
<h4>{{ 'MEDDIC.SCORE_NAMES.' + scoreI18nKey | translate }}</h4>
